import React, { useEffect } from "react";
import QrScan from "react-qr-reader";
import { makeStyles } from "@material-ui/core/styles";
import { Button, LinearProgress, Paper, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import axios from "axios";
import HospitalData from "./HospitalData";
import { config } from "../../config";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "max-content",
    margin: "auto",
    overflow: "hidden",
    padding: "10px",
  },
  ScanAgainBtn: {
    margin: "10px 0px",
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
    color: "white",
  },
}));

function QRReader({ qrscan, setQrscan, hosData, setHosData, setPatientData }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (qrscan !== "No result") {
      axios
        .post(`${config.url.BACKEND}/scanUser`, {
          uid: qrscan,
        })
        .then((res) => {
          setHosData(res.data);
          // enqueueSnackbar("Scanned !", { variant: "success" });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .post(`${config.url.BACKEND}/getPatientInfo`, {
          uid: qrscan,
        })
        .then((res) => {
          setPatientData(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [qrscan]);

  const handleScan = (data) => {
    if (data) {
      setQrscan(data, () => {
        enqueueSnackbar("Scanned !", { variant: "success" });
      });
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  return (
    <>
      {hosData.length === 0 ? (
        qrscan !== "No result" ? (
          <LinearProgress />
        ) : (
          <Paper className={classes.paper}>
            <QrScan
              delay={300}
              onError={handleError}
              onScan={handleScan}
              onLoad={() => {
                if (qrscan === "No result") {
                  enqueueSnackbar("Scanning Initiated !", {
                    variant: "info",
                  });
                }
              }}
              style={{ width: 320 }}
            />

            <Typography
              variant="caption"
              style={{ marginTop: "10px" }}
              display="block"
              gutterBottom
              align="center"
            >
              Scan QR code
            </Typography>
          </Paper>
        )
      ) : (
        <>
          <HospitalData hosData={hosData} docLogin />

          <Button
            className={classes.ScanAgainBtn}
            color="primary"
            variant="contained"
            onClick={() => {
              setQrscan("No result");
              setHosData([]);
              setPatientData([]);
            }}
          >
            Scan Again
          </Button>
        </>
      )}
    </>
  );
}

export default QRReader;
